"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ref, _ref2;

import { Record } from 'immutable';
import { Fields, System } from "Constants/objects";
import router from 'Router';
import { itemWithIconTemplate } from "D5Utils/functions";
var _System$TITLE_TYPE = System.TITLE_TYPE,
    ICON = _System$TITLE_TYPE.ICON,
    ICON_AND_TITLE = _System$TITLE_TYPE.ICON_AND_TITLE,
    TITLE = _System$TITLE_TYPE.TITLE;
export var ToolBarBtnRec = new Record((_ref = {
  hint: '',
  text: '',
  template: null,
  disabled: false,
  elementAttr: null,
  iconType: ''
}, _defineProperty(_ref, Fields.ButtonType, null), _defineProperty(_ref, Fields.ActionFormID, null), _defineProperty(_ref, "url", ''), _defineProperty(_ref, "onClick", null), _defineProperty(_ref, "titleType", null), _ref));
export var TableContextMenuBtn = new Record((_ref2 = {
  template: null,
  text: '',
  beginGroup: false,
  disabled: false,
  iconType: ''
}, _defineProperty(_ref2, Fields.ButtonType, null), _defineProperty(_ref2, Fields.ActionFormID, null), _defineProperty(_ref2, "elementAttr", null), _defineProperty(_ref2, "url", ''), _defineProperty(_ref2, "items", []), _defineProperty(_ref2, "onClick", null), _defineProperty(_ref2, "titleType", null), _ref2));

var BaseToolbarButtonProp =
/*#__PURE__*/
function () {
  function BaseToolbarButtonProp(_ref3) {
    var _this = this;

    var _ref3$isContextMenu = _ref3.isContextMenu,
        isContextMenu = _ref3$isContextMenu === void 0 ? false : _ref3$isContextMenu,
        props = _objectWithoutProperties(_ref3, ["isContextMenu"]);

    _classCallCheck(this, BaseToolbarButtonProp);

    _defineProperty(this, "_props", {
      location: 'before',
      widget: System.DX_CONTROLS.dxButton,
      locateInMenu: 'auto',
      showText: 'always',
      options: null
    });

    _defineProperty(this, "elementAttr", {});

    _defineProperty(this, "onClick", function (e) {});

    _defineProperty(this, "updateUUID", function (formUUID) {
      _this._isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    });

    this._isContextMenu = isContextMenu;
    if (this._isContextMenu) this._props = new TableContextMenuBtn(props).toObject();else this._props.options = new ToolBarBtnRec(props).toObject();
    this.template = this.template.bind(this);
    this._props.updateUUID = this.updateUUID;
    this.setOptions({
      template: typeof props.template !== 'undefined' ? props.template : this.template,
      elementAttr: props.elementAttr || this.elementAttr,
      onClick: props.onClick || this.onClick
    });

    var _this$getOptions = this.getOptions(),
        titleType = _this$getOptions.titleType; //titleType == null - если это системные кнопки (не с сервера)


    if (titleType == null && !this._isContextMenu) {
      this.setOptions({
        titleType: ICON
      });
    } else if (this._isContextMenu && (titleType == null || titleType === ICON)) {
      this.setOptions({
        titleType: ICON_AND_TITLE
      });
    }
  }

  _createClass(BaseToolbarButtonProp, [{
    key: "props",
    value: function props() {
      return _objectSpread({}, this._props);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      if (this._isContextMenu) {
        this._props = _objectSpread({}, this._props, options);
      } else this._props.options = _objectSpread({}, this._props.options, options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      if (this._isContextMenu) {
        return this._props;
      } else return this._props.options;
    }
  }, {
    key: "template",
    value: function template(data, element) {
      var _this$getOptions2 = this.getOptions(),
          iconType = _this$getOptions2.iconType,
          titleType = _this$getOptions2.titleType;

      var item = $(itemWithIconTemplate({
        text: data.text,
        type: System.TEMPLATE_TYPE.BUTTON,
        icon: iconType,
        titleType: titleType
      }));
      this.onMouseDown(item);
      return item;
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(element) {
      var _this$getOptions3 = this.getOptions(),
          url = _this$getOptions3.url;

      if (url) {
        $(element).off('mousedown');
        $(element).on('mousedown', function (e) {
          if (e.which === 2 || e.which === 1 && e.ctrlKey) {
            //middle mouse button, LMK+Ctrl
            var newWin = window.open();
            newWin.document.location = document.location.origin + document.location.pathname + url;
          } else if (e.which !== 3) {
            //not RMK
            router.navigateTo(url);
          }
        });
      }
    }
  }]);

  return BaseToolbarButtonProp;
}();

_defineProperty(BaseToolbarButtonProp, "create", function (options) {
  return new BaseToolbarButtonProp(options).props();
});

export { BaseToolbarButtonProp as default };